import styled from 'styled-components';
import Button from '../button';
import { breakpoint } from '../theme/breakpoint';
import AutoSuggest from '../input-fields/auto-suggest';
import { Container } from '../styled/containers';
import { h3 } from '../styled/typography';

// This is a magic number providing a sensible size for search button for now
const SearchButtonWidth = '48px';
const SearchButtonHeight = '37px';
const SearchButtonHeightLarge = '48px';

export const StyledContainer = styled(Container)`
  margin-bottom: ${({ theme }) => theme.spacing.medium};
`;

export const AdviceSearchTitle = styled.h3`
  ${h3}
  margin-top: 0;
  margin-bottom: ${({ theme }) => theme.spacing.standard};
`;

export const SearchField = styled(AutoSuggest)`
  width: 100%;
  flex: 1;
  margin-bottom: 0;
`;

export const SearchButton = styled(Button)`
  width: ${SearchButtonWidth};
  height: ${SearchButtonHeight};
  margin-left: 4px;
  padding: ${({ theme }) => theme.spacing.tiny};

  svg {
    margin-right: 0;
    vertical-align: middle;
  }

  ${breakpoint.tablet`
    height: ${SearchButtonHeightLarge};
  `}
`;

export const SuggestionsHolder = styled.div`
  font-size: ${({ theme }) => theme.fontsize.small};
  margin-bottom: ${({ theme }) => theme.spacing.tiny};
  margin-top: ${({ theme }) => theme.spacing.tiny};

  ${breakpoint.tablet`
    margin-bottom: 0;
    margin-top: 0;
  `};
`;

export const FlexWrapper = styled.div`
  display: flex;

  + ${SuggestionsHolder} {
    margin-top: ${({ theme }) => theme.spacing.standard};
  }
`;
